export default {
  header: {
    review_us: 'Beoordeel ons op Google',
    upload: 'Google-review uploaden',
    not_now: 'Niet nu',
  },
  steps: {
    how_it_works: 'Hoe het werkt',
    step_1: {
      title: 'Stap',
      description: 'Schrijf een review over {{name}} op Google',
    },
    step_2: {
      title: 'Stap',
      description: 'Upload een screenshot van je geplaatste review (zie voorbeeld hieronder)',
    },
  },
  buttons: {
    upload_screenshot: 'Screenshot uploaden',
    leave_google_review: 'Google-review schrijven',
    submit_screenshot: 'Screenshot indienen',
    return: 'Terug',
  },
  enter_name: {
    title: 'Naam bij je Google-review',
    place_holder: 'Naam invoeren',
  },
  screenshot_uploaded: {
    title: 'Screenshot geüpload',
    description: 'Scroll naar beneden voor volledig screenshot',
  },
  loading: {
    processing: 'Je geplaatste review wordt beoordeeld',
  },
  error_messages: {
    upload_failed: 'Screenshot uploaden mislukt. Probeer het opnieuw.',
    review_already_uploaded:
      'Het lijkt erop dat je al een screenshot van een Google-review hebt geüpload. Je kunt maximaal één keer worden beloond voor een Google-review 😊',
    name_missing: {
      description: 'Voer de naam in die bij je Google-review is geplaatst, zodat we je gegevens kunnen koppelen.',
      button: {
        title: 'Oké',
      },
    },
  },
};
